export const PRODUCT_TYPE_GOOD = '0';
export const PRODUCT_TYPE_SERVICE = '1';

export const NAME_KEY = 'name';
export const DESCRIPTION_KEY = 'description';
export const TYPE_KEY = 'type';
export const SKU_KEY = 'sku';
export const UNIT_KEY = 'unit';
export const CATEGORY_ID_KEY = 'categoryId';

export const GENERAL_DROMO_FIELDS = [
    {
        label: 'Name',
        key: NAME_KEY,
        type: 'string',
        validators: [
            {
                validate: 'required',
            },
        ],
    },
    {
        label: 'Description',
        key: DESCRIPTION_KEY,
        type: 'string',
    },
    // Category will be provided by name in CSV; UI will upgrade this to a select.
    {
        label: 'Category',
        key: CATEGORY_ID_KEY,
        type: 'string',
        alternateMatches: ['Category', 'category', 'Category Name'],
    },
    {
        label: 'Type',
        key: TYPE_KEY,
        type: 'select',
        selectOptions: [
            {label: 'Good', value: PRODUCT_TYPE_GOOD},
            {label: 'Service', value: PRODUCT_TYPE_SERVICE},
        ],
    },
    {
        label: 'SKU',
        key: SKU_KEY,
        type: 'string',
    },
    {
        label: 'Term',
        key: UNIT_KEY,
        type: 'select',
        validators: [
            {
                validate: 'require_with_values',
                fieldValues: {type: 'Service'},
            },
        ],
        selectOptions: [
            {label: 'Minute', value: 'minute'},
            {label: 'Hour', value: 'hour'},
            {label: 'Day', value: 'day'},
            {label: 'Week', value: 'week'},
            {label: 'Month', value: 'month'},
            {label: 'Quarter', value: 'quarter'},
            {label: 'Year', value: 'year'},
        ],
        alternateMatches: ['unit', 'Unit'],
    },
] as const;

export const NUMBER = 'number';

export const MIN_NUMBER_VALUE = 0;
